import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmResourceConsumption, setFootprintingFarmResourceConsumptionAdmin } from "services";

import { footprintingFarmPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries, shouldRetryQueryError } from "utils";

import { FOOTPRINTING_FARM_RESOURCE_CONSUMPTION } from "consts";

import { FootprintingFarmResourceConsumption } from "models";

export const useMutateFootprintingFarmResourceConsumption = (
  farmId: string,
  year: number,
  payload: FootprintingFarmResourceConsumption,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingFarmResourceConsumptionAdmin : setFootprintingFarmResourceConsumption;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_RESOURCE_CONSUMPTION],
      mutationFn: () => queryFn(payload, primaryDataId),
      retry: shouldRetryQueryError(),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_FARM_RESOURCE_CONSUMPTION, primaryDataId, isAdmin],
          ...footprintingFarmPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
